import * as Sentry from '@sentry/react';
import { DirectUpload_Read, postV1DirectUploads } from '@treadinc/horizon-api-spec';
import { useCallback } from 'react';

import { checksum } from './checksum';

const KML_CONTENT_TYPE = 'application/vnd.google-earth.kml+xml';
const KMZ_CONTENT_TYPE = 'application/vnd.google-earth.kmz';
const DEFAULT_CONTENT_TYPE = 'application/octet-stream';

const getContentType = (file: File) => {
  if (file.name.endsWith('.kml')) {
    return KML_CONTENT_TYPE;
  } else if (file.name.endsWith('.kmz')) {
    return KMZ_CONTENT_TYPE;
  } else if (file.type) {
    return file.type;
  } else {
    Sentry.captureMessage("DirectUploads: couldn't determine content type", {
      level: 'error',
      extra: {
        filename: file.name,
      },
    });
    return DEFAULT_CONTENT_TYPE;
  }
};

export const useDirectUploads = () => {
  const createDirectUpload = useCallback(
    async (file: File): Promise<DirectUpload_Read> => {
      const directUpload = await postV1DirectUploads({
        body: {
          filename: file.name,
          content_type: getContentType(file),
          byte_size: file.size,
          checksum: await checksum(file),
        },
      });
      const signedUrl = directUpload.data.data.direct_upload.url;
      const headers = {};
      if (directUpload.data.data.direct_upload.headers) {
        Object.assign(headers, directUpload.data.data.direct_upload.headers);
      }

      await fetch(signedUrl, {
        method: 'PUT',
        body: file,
        headers,
      });

      return directUpload.data.data;
    },
    [],
  );
  return {
    createDirectUpload,
  };
};
